import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';

export function configureI18N() {
    const missing = new Map<string, Map<string, { [key: string]: string }>>();
    i18n
        .use(initReactI18next)
        .use(Backend)
        .init({
            lng: 'no',
            fallbackLng: 'no',
            backend: {
                // for all available options read the backend's repository readme file
                loadPath: './locales/{{lng}}/{{ns}}.json'
            },
            interpolation: {
                escapeValue: false,
            },
            returnNull: false,
            ns: ['common'],
            defaultNS: 'common',
            react: {
                useSuspense: true
            },
            saveMissing: true,
            keySeparator: false,
            missingKeyHandler: (lngs: readonly string[], ns: string, key: string, fallbackValue: string, updateMissing: boolean, options: any) => {
                 console.warn(`Missing translation for '${key}' in namespace '${ns}' for languages`, lngs, `falling back to '${fallbackValue}'`);
                for (const lng of lngs) {
                    let map = missing.get(lng);
                    if (!map) {
                        map = new Map();
                        missing.set(lng, map);
                    }
                    let nsMap = map.get(ns);
                    if (!nsMap) {
                        nsMap = {};
                        map.set(ns, nsMap);
                    }
                    nsMap[key] = fallbackValue;

                    localStorage.setItem(`${lng}-${ns}`, JSON.stringify(nsMap, null, 4));
                }
            }
        },(err, t) => { /* resources are loaded */ });
}
